import { Query } from 'react-apollo'
import users, { Users, UsersInput } from '../../graphql/queries/usersLean'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class UsersLeanQuery extends Query<Users, UsersInput> {}

const UsersLeanQueryCompleted = withQuery(users)(UsersLeanQuery)

export type UsersLeanQueryProps = GetProps<typeof UsersLeanQueryCompleted>
export type UsersLeanQueryResult = Users

export default UsersLeanQueryCompleted



// WEBPACK FOOTER //
// ./src/components/queries/UsersLeanQuery.tsx